export default __webpack_public_path__ + "static/media/safeguard.24627a6f.png";